import {
  Menu,
  MenuItemBasicWithSides,
  MenuOptionGroupBasicWithItems,
  MenuPreview,
} from "client/jspPlatformExperiment";
import { DisplayMenuItem } from "models/menu/menuContentsReducer";

export const isMenu = (o: unknown): o is Menu => {
  return !!o && typeof o === "object" && "sections" in o;
};

export const isMenuPreview = (o: unknown): o is MenuPreview => {
  return !!o && typeof o === "object" && isMenu(o) && "menu_loop" in o;
};

export const isMenuArray = (o: Array<unknown>): o is Menu[] => {
  return !!o && typeof o === "object" && o.every(isMenu);
};

export const isDisplayMenuItem = (o: unknown): o is DisplayMenuItem => {
  return (
    !!o &&
    typeof o === "object" &&
    "option_type" in o &&
    o.option_type === "menu item"
  );
};

export const isMenuItemBasicWithSides = (
  o: unknown,
): o is MenuItemBasicWithSides => {
  return (
    !!o &&
    typeof o === "object" &&
    "option_type" in o &&
    o.option_type === "menu item"
  );
};

export const isMenuSectionBasicWithItems = (
  o: unknown,
): o is MenuOptionGroupBasicWithItems => {
  return (
    !!o &&
    typeof o === "object" &&
    "options" in o &&
    "option_type" in o &&
    o.option_type === "option group"
  );
};

/**
 * Helper function to identify à la carte menus
 * À la carte menus are typically identified by having "à la carte" in their name
 * or by being associated with looping_day_index === 0 in menu loops
 */
export const isALaCarteMenu = (menu: Menu): boolean => {
  return (
    (menu.name?.toLowerCase().includes("à la carte") ||
      menu.name?.toLowerCase().includes("a la carte")) ??
    false
  );
};

/**
 * Helper function to identify texture menus.
 * Texture menus are typically identified by having "texture" in their name
 */
export const isTextureMenu = (menu: Menu): boolean => {
  return menu.name?.toLowerCase().includes("texture") ?? false;
};
